import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex alignC top-button-group" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8 mar-l-16" }, "跟进时间", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8 mar-l-16" }, "跟进人", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8 mar-l-16" }, "到期类型", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "搜索", -1)
const _hoisted_7 = { class: "flex flexR mar-t-22" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_date_picker, {
        modelValue: _ctx.dateRange,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dateRange = $event)),
        class: "mar-r-8",
        type: "daterange",
        "unlink-panels": "",
        "range-separator": "-",
        "start-placeholder": "开始日期",
        "end-placeholder": "结束日期",
        onChange: _ctx.getTableData
      }, null, 8, ["modelValue", "onChange"]),
      _hoisted_4,
      _createVNode(_component_el_select, {
        class: "mar-r-8",
        style: {"width":"140px"},
        modelValue: _ctx.searchParams.o_id,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchParams.o_id = $event)),
        placeholder: "请选择",
        clearable: "",
        onChange: _ctx.getTableData
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.staffList, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              label: item.name,
              value: item.id,
              key: item.id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"]),
      _hoisted_5,
      _createVNode(_component_el_select, {
        class: "mar-r-8",
        style: {"width":"150px"},
        modelValue: _ctx.searchParams.maturity_type,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchParams.maturity_type = $event)),
        placeholder: "请选择",
        clearable: "",
        onChange: _ctx.getTableData
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "保养到期",
            value: 1
          }),
          _createVNode(_component_el_option, {
            label: "年检到期",
            value: 2
          }),
          _createVNode(_component_el_option, {
            label: "商业险到期",
            value: 3
          }),
          _createVNode(_component_el_option, {
            label: "交强险到期",
            value: 4
          })
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"]),
      _createVNode(_component_el_input, {
        class: "mar-l-16 mar-r-18",
        modelValue: _ctx.searchParams.car_code,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.searchParams.car_code = $event)),
        placeholder: "车牌号码",
        "suffix-icon": "el-icon-search",
        style: {"width":"180px"},
        onChange: _ctx.getTableData
      }, null, 8, ["modelValue", "onChange"]),
      _createVNode(_component_el_button, {
        class: "bg-red",
        onClick: _ctx.getTableData
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode("div", null, [
      _withDirectives(_createVNode(_component_el_table, {
        data: _ctx.tableData,
        stripe: "",
        style: {"width":"100%"},
        class: "table",
        "header-cell-style": _ctx.headClass
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "车牌信息",
            align: "center",
            "min-width": "120"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.car_code || scope.row.car?.code), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "到期类型",
            align: "center",
            "min-width": "180"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.maturity_type_text || '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "跟进人",
            align: "center",
            "min-width": "100"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.gjr?.nickname), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "跟进日期",
            align: "center",
            "min-width": "160"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.add_time_text), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "跟进内容",
            align: "center",
            "min-width": "400"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.remark), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "header-cell-style"]), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode(_component_el_pagination, {
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        "current-page": _ctx.currentPage,
        "page-sizes": [10, 20, 50, 100],
        "page-size": _ctx.pageSize,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.total
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
    ])
  ]))
}